<script setup lang="ts">
  import { computed } from "vue";
  import { useRoute } from "vue-router";
  import { storeToRefs } from "pinia";
  import { Loader2 } from "lucide-vue-next";
  import { Button } from "@/components/ui/button";
  import { useMasterReportsStore } from "@/stores/masterReports/masterReports";
  import { useSlideTemplatesStore } from "@/stores/slideTemplates";
  import { useChartTemplatesStore } from "@/stores/chartTemplates/chartTemplates";

  const route = useRoute();
  const routeName = computed(() => route.name as string);

  const masterReportsStore = useMasterReportsStore();
  const { hasChanges: hasMasterReportChanges, isSaving: isSavingMasterReport } = storeToRefs(masterReportsStore);
  const { saveSetup: handleMasterReportSave } = masterReportsStore;

  const slideTemplatesStore = useSlideTemplatesStore();
  const { hasChanges: hasSlideTemplateChanges, saving: isSavingSlideTemplates } = storeToRefs(slideTemplatesStore);
  const handleSlideTemplatesSave = () => slideTemplatesStore.saveAllChanges();

  const chartTemplatesStore = useChartTemplatesStore();
  const { hasChanges: hasChartTemplateChanges, saving: isSavingChartTemplates } = storeToRefs(chartTemplatesStore);
  const handleChartTemplatesSave = () => chartTemplatesStore.saveAllChanges();
</script>

<template>
  <div class="flex items-center gap-3">
    <Button
      v-if="routeName === 'MasterReportSetup'"
      :disabled="!hasMasterReportChanges || isSavingMasterReport"
      @click="handleMasterReportSave">
      <Loader2
        v-if="isSavingMasterReport"
        class="w-4 h-4 mr-2 animate-spin" />
      Save
    </Button>
    <Button
      v-else-if="routeName === 'MasterReportSlides'"
      :disabled="!hasSlideTemplateChanges || isSavingSlideTemplates"
      @click="handleSlideTemplatesSave">
      <Loader2
        v-if="isSavingSlideTemplates"
        class="w-4 h-4 mr-2 animate-spin" />
      Save
    </Button>
    <Button
      v-else-if="routeName === 'MasterReportCharts'"
      :disabled="!hasChartTemplateChanges || isSavingChartTemplates"
      @click="handleChartTemplatesSave">
      <Loader2
        v-if="isSavingChartTemplates"
        class="w-4 h-4 mr-2 animate-spin" />
      Save
    </Button>
  </div>
</template>
